export const trimmedPaste = (event, onChangeCallback) => {
  const pastedText = event.clipboardData.getData('text');
  const trimmed = pastedText.trim();
  if (trimmed !== pastedText) {
    event.preventDefault();
    const { selectionStart, selectionEnd, value } = event.target;
    const newValue =
      value.slice(0, selectionStart) + trimmed + value.slice(selectionEnd);
    onChangeCallback({ target: { value: newValue } });
  }
};

export default trimmedPaste;
